import { GILL_ROY_DESK_ICON } from "constants/index";
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
body, html {​​​​​
  margin:0;
  padding:0;
  font-family: 'roboto_slabregular';
}​​​​​
svg{
  max-width:100%;
}
.saveBtnSuccess{
  border-radius: 27px;
  background-color: #27ce0a;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  padding: 9px 22px;
  line-height: 1.2;
  border: solid 1px #27ce0a;
  font-family: "helveticaneuebold";
  transition: 0.3s;
  &:active,
  &:focus {
    box-shadow: 0 0 0 0.2rem rgb(40 167 69 / 50%);
  }
  &.outline {
    background-color: #ffffff;
    color: #27ce0a;
    &:active,
    &:focus,
    &:hover {
      background-color: #27ce0a;
      color: #ffffff;
    }
  }
  &:disabled {
    cursor: default;
    opacity: 0.6;
  } 
}
.stripo-hide{
  opacity: 0;
}
body {
  &.gillRoy-index {
    .fc-widget-small, .freshDesk-Bot {
      z-index: -1 !important;
    }
  }
}
body{
  &.publish-gillRoy-index {
    .freshDesk-Bot{
      right:680px !important;
    }
    .fc-widget-small{
      right:615px !important;
    }
    @media all and (max-width: 1439px), (-webkit-device-pixel-ratio: 1.25) {
        .freshDesk-Bot{
          right:504px !important;
        }
        .fc-widget-small{
          right:440px !important;
        }
    }
  }
}
.freshDesk-Bot {
  position: fixed;
  right: 80px;
  bottom: 80px;
  z-index: 21474836001;
  cursor: pointer;
}
  		  
.freshDesk-Bot::after {
  content: '';
  padding: 0px;
  background-image: url(${GILL_ROY_DESK_ICON});
  background-position: center;
  background-size: cover;
  width: 60px;
  height: 60px;
  top: 0px;
  left: 0px;
  position: absolute;
}



`;

export default GlobalStyle;
